module.exports = __webpack_public_path__ + "img/kogata_sam.136a55c1.gif";